export const MESSAGE_EXPIRATION_NONE = 0
